<script setup>
import Swal from "sweetalert2";
import useDates from "@/composables/useDates";

const {
  formattedDate,
  diffBetweenDates,
  diffBetweenDatesHumanized,
  diffInWeekdays
} = useDates()

const props = defineProps({
  websiteId: {
    type: Number,
    required: true,
  },
  hasKit: {
    type: Boolean,
    required: true,
  },
  scheduleDates: {
    type: [Object, null],
    required: true,
  },
  canRemoveKit: {
    type: Boolean,
    required: true,
  }
})
const completeSingleUserUpgrade = () => {
  Swal.fire({
    icon: 'warning',
    title: 'Completed Upgrade',
    html: `This should only be used for migrating Software Plus customers, once:
      <br>
      <br>
      <ul class="text-left">
        <li>Customers subscription has been updated with the correct website and Kit addon price</li>
        <li>The website price ID has been updated (if needed)</li>
      </ul>
      This process will then:
      <br>
      <br>
      <ul class="text-left">
        <li>Create a kit schedule</li>
        <li>Set up the website addon within the platform</li>
        <li>Start the process for kit</li>
      </ul>
    `,
    confirmButtonText: 'Complete Upgrade',
    showCancelButton: true,
    preConfirm() {
      window.location.href = `/admin/complete-kit-upgrade/${props.websiteId}`;
    }
  });
}

</script>

<template>
  <div class="row">
    <div class="col-md-4">
      <p class="mrg-top-10 text-dark">
        <b>Kit</b>
      </p>
    </div>
    <div class="col-md-8">
      <p
        v-if="!hasKit"
        class="xs-mb-0"
      >
        <button
          class="btn btn-sm btn-default btn-icon xs-mt-5 tooltipster"
          title="Add Kit to Website"
          @click="completeSingleUserUpgrade"
        >
          <i class="fad fa-cog" />
          Add Kit to Website
        </button>
      </p>
      <p class="xs-mb-0">
        <a
          :href="`/admin/website/${props.websiteId}/kit`"
          class="btn btn-sm btn-default btn-icon"
        >
          <i class="far fa-robot" />
          Kit Settings
        </a>
      </p>
      <p class="xs-mb-0">
        <a
          :href="`/admin/website/${props.websiteId}/kit/pages`"
          class="btn btn-sm btn-default btn-icon"
        >
          <i class="far fa-robot" />
          Kit Pages
        </a>
      </p>
    </div>
  </div>
  <div
    v-if="scheduleDates"
    class="row"
  >
    <div class="col-md-4">
      <p class="mrg-top-10 text-dark">
        <b>Kit Schedule Dates</b>
      </p>
    </div>
    <div class="col-md-6">
      <table class="table table-sm text-left">
        <tbody>
          <tr>
            <td>
              <strong>Current Weekday</strong>
            </td>
            <td>
              {{ diffInWeekdays(scheduleDates.thisPeriodStartDate) }} (Month {{ Math.ceil(diffBetweenDates(undefined, scheduleDates.startDate, 'months', true)) }})
            </td>
          </tr>
          <tr>
            <td>
              <strong>Day 4</strong>
            </td>
            <td>
              {{ formattedDate(scheduleDates.dayFourDate, 'DD/MM/YYYY HH:mm') }} ({{ diffBetweenDatesHumanized(scheduleDates.dayFourDate) }})
            </td>
          </tr>
          <tr>
            <td>
              <strong>Day 6</strong>
            </td>
            <td>
              {{ formattedDate(scheduleDates.daySixDate, 'DD/MM/YYYY HH:mm') }} ({{ diffBetweenDatesHumanized(scheduleDates.daySixDate) }})
            </td>
          </tr>
          <tr>
            <td>
              <strong>Day 11</strong>
            </td>
            <td>
              {{ formattedDate(scheduleDates.dayElevenDate, 'DD/MM/YYYY HH:mm') }} ({{ diffBetweenDatesHumanized(scheduleDates.dayElevenDate) }})
            </td>
          </tr>
          <tr>
            <td>
              <strong>Day 16</strong>
            </td>
            <td>
              {{ formattedDate(scheduleDates.daySixteenDate, 'DD/MM/YYYY HH:mm') }} ({{ diffBetweenDatesHumanized(scheduleDates.daySixteenDate) }})
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <a
          v-if="canRemoveKit"
          class="btn btn-xs xs-mt-5 btn-danger clickConfirm"
          :href="`/website/settings/${websiteId}/remove-kit`"
        >
          <i class="far fa-trash mr-1" />
          <span>Remove Kit</span>
        </a>
      </div>
    </div>
  </div>
  <hr>
</template>
